// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2NX20","footer":"ModalCreateQualiphyProcedure_footer__2h1KJ","additionData":"ModalCreateQualiphyProcedure_additionData__3rtSo"};